export default __webpack_public_path__ + "static/media/greyBed.475f2c5c.svg";